// extracted by mini-css-extract-plugin
module.exports = {"select-config-container":"SettingsTab_select-config-container__2GgXg"};